export default __webpack_public_path__ + "static/media/014.47df360f.jpg";